<template>
    <SmallModal
        :show="show"
        :z-index-class="zIndexClass"
        @close="$emit('close')"
    >
        <div class="sm:flex sm:items-start">
          <div class="mt-3 text-center sm:mt-0 sm:text-left">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Add new project for {{ client?.name }}
            </h3>
          </div>
        </div>
        <div class="my-8 w-full flex flex-col space-y-4">
          <div>
            <label
              for="name"
              class="block text-sm font-medium text-gray-700"
            >Project Name</label>
            <div class="mt-1 relative rounded-md shadow-sm">
              <input
                ref="projectName"
                id="name"
                v-model="form.name"
                type="text"
                name="name"
                class="block w-full pr-10 focus:outline-none sm:text-sm rounded-md"
                :class="{'focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300': form.errors.name, 'focus:ring-indigo-200 focus:border-indigo-300 border-gray-300': !form.errors.name}"
                placeholder="Project title"
                aria-invalid="true"
                aria-describedby="name-error"
              >
              <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <!-- Heroicon name: solid/exclamation-circle -->
                <svg
                  v-if="form.errors.name"
                  class="h-5 w-5 text-red-500"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
            <p
              v-if="form.errors.name"
              id="email-error"
              class="mt-2 text-sm text-red-600"
            >
              {{ form.errors.name }}
            </p>
          </div>
        </div>
        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <button
            type="button"
            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
            @click="save"
          >
            Add
          </button>
          <button
            type="button"
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
            @click="$emit('close')"
          >
            Cancel
          </button>
        </div>
    </SmallModal>
</template>

<script setup>
import {ref, onMounted, watch} from "vue";
import SmallModal from './SmallModal.vue'
const emit = defineEmits(['created'])

const form = ref({
    name: '',
    key_account_manager: null,
    errors: {}
})

const props = defineProps({
    query: {
        type: String,
        default: ''
    },
    show: {
        type: Boolean,
        default: false
    },
    client: {
        type: Object,
        required: true
    },
    zIndexClass: {
      type: String,
      required: false,
      default: 'z-50',
    }
})

const team_members = ref([]);
const projectName = ref(null)

onMounted(() => {
    form.value.name = props.query
})

watch(() => props.show, (newValue) => {
    if (newValue) {
        form.value.name = props.query
    }
    setTimeout(() => {
        projectName.value.focus()
    }, 50)
});

function save() {
    axios.post(route('api.clients.projects.store', {
        client: props.client
    }), {
        name: form.value.name
    }).then(response => {
        emit('created', response.data)
        emit('close')
        form.value.name = ''
        form.value.errors = {}
    }).catch(error => {
        form.value.errors = error.data.errors
    })
}
</script>
